import onboardingSerivce from '@App/Auth/services/onboardingService'
import CoreDialog from '@Core/Components/Dialog/CoreDialog'
import { useBoolean, useRequest, useUpdateEffect } from 'ahooks'
import React, { useEffect, useState } from 'react'
import StepOne from './StepOne'
import { useCoreAuth } from '../CoreAuthProvider'
import AboutUs from './AboutUs'
import CreateWorkspace from './CreateWorkspace'
import { useCoreWorkspaceContext } from '../CoreWorkspaceProvider'
import { isUserStudent } from '@Core/Helpers/User'
import VerifyOTP from './VerifyMobileForm'
// import PropTypes from 'prop-types'

const CoreOnboardingContext = React.createContext({
	onboardingCompleted: false,
	handleCloseOnboarding: () => {},
	setStep: step => {},
	setOnboardingCompleted: () => {}
})

export const useCoreOnboardingContext = () => React.useContext(CoreOnboardingContext)

const CoreOnboardingProvider = ({ skipWorkspace = false, ...props }) => {
	const { user, isAuthenticated } = useCoreAuth()
	// const { currentWorkspace } = useCoreWorkspaceContext()
	const [open, { setFalse, setTrue }] = useBoolean(false)
	const [step, setStep] = useState('info')
	const [onboardingCompleted, setOnboardingCompleted] = useState(false)
	// console.log('============= user', isAuthenticated)
	useEffect(() => {
		if (isAuthenticated) {
			if (user?.username?.indexOf('Z195') === 0) {
				setFalse()
				setOnboardingCompleted(true)
				return () => {}
			}
			if (isUserStudent()) {
				if (!user?.info?.fullname || !user?.onboarding_data?.school_id) {
					setStep('info')
					setTrue()
					return () => {}
				}
			} else if (!user?.onboarding_data?.working_office) {
				setStep('info')
				setTrue()
				return () => {}
			}
			if (!user?.onboarding_data?.hear_about_us) {
				setStep('about-us')
				setTrue()
			} else if (!user?.onboarding_data?.use_app_for) {
				setStep('about-us')
				setTrue()
			}
			// else if (!user?.onboarding_data?.is_verify_mobile) {
			// 	setStep('verify')
			// 	setTrue()
			// }
			else {
				// setStep('info')
				// setTrue()
				setFalse()
				setOnboardingCompleted(true)
			}
			// else if (!currentWorkspace?.id && !skipWorkspace) {
			// 	setStep('create-workpsace')
			// 	setTrue()
			// }
			// setStep('info')
			// setTrue()
		}
	}, [JSON.stringify(user), isAuthenticated])

	const renderDiglogOnboarding = () => {
		return (
			<CoreDialog
				open={open}
				// handleClose={setFalse}
				dialogTitle="Chào mừng bạn đến với EduQuiz"
				dialogContent={
					<div>
						{step === 'info' && <StepOne handleNext={() => setStep('about-us')} />}
						{step === 'about-us' && <AboutUs handleBack={() => setStep('info')} />}
						{step === 'verify' && (
							<VerifyOTP
								onVerify={() => {
									setFalse()
									setOnboardingCompleted(true)
								}}
							/>
						)}

						{/* {step === 'create-workpsace' && <CreateWorkspace />} */}
					</div>
				}
				maxWidth={step === 'verify' ? 'sm' : 'md'}
			/>
		)
	}

	const context = {
		handleCloseOnboarding: setFalse,
		setStep,
		onboardingCompleted,
		setOnboardingCompleted
	}

	if (!isAuthenticated) {
		return props.children
	}

	return (
		<CoreOnboardingContext.Provider value={context}>
			{renderDiglogOnboarding()}
			{onboardingCompleted ? props.children : null}
		</CoreOnboardingContext.Provider>
	)
}

// CoreOnboardingProvider.defaultProps = {}

// CoreOnboardingProvider.propTypes = {}

export default React.memo(CoreOnboardingProvider)
